import Vue from 'vue'
import Vuex from 'vuex'
import Product from './product/product'
import Icon from './_common/_icons'
import Drawer from './components/drawer'
import SideSheet from './components/sideSheet'
import Snackbar from './components/snackBar'
import Profile from './user/profile'
import Countries from './_common/_countries'
import Regions from './_common/_regions'
import Misc from './_common/_misc'
import Common from './_common'
import API from './api'
import Casino from './product/casino'
import Footer from './components/footer'

Vue.use(Vuex)

export default new Vuex.Store({
  state: { // reserved for IT
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Product,
    Icon,
    Drawer,
    SideSheet,
    Snackbar,
    Profile,
    Countries,
    Regions,
    Misc,
    Common,
    API,
    Casino,
    Footer
  }
})
